<template>
    <b-modal :active.sync="orderDetailModal" scrol="keep">
        <div class="modal-card has-text-centered modal-add-to-list" style="width:auto;">
            <div class="modal-card-body">
                <div class="has-text-right">
                    <a class="has-text-danger" @click="closeModal">
                        <b-icon icon="times " sizes="is-small"></b-icon>
                    </a>
                </div>
                <div class="container">
                    <div class="columns is-multiline has-text-left">
                        <div class="column is-half">
                            <b-field label="Nombre">
                                <b-input
                                v-model="data.firstName"
                                required
                                >
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-half">
                            <b-field label="Apellido">
                                <b-input
                                v-model="data.lastName"
                                required>
                                </b-input>
                            </b-field>
                        </div>

                        <div class="column is-two-thirds">
                            <b-field label="Direccion">
                                <b-input 
                                v-model="data.address"
                                required>
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-one-third">
                            <b-field label="Numero domicilio">
                                <b-input
                                v-model="data.number"
                                required>
                                </b-input>
                            </b-field>
                        </div>

                        <div class="column is-one-third">
                            <b-field label="Localidad/Ciudad">
                                <b-input
                                v-model="data.location"
                                required>
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-one-third">
                            <b-field label="Departamento">
                                <b-input
                                v-model="data.region"
                                required>
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-one-third">
                            <b-field label="Codigo Postal">
                                <b-input
                                v-model="data.zipCode"
                                required>
                                </b-input>
                            </b-field>
                        </div>
                        
                        <div class="column is-one-third">
                            <b-field label=" Tipo Documento de identidad">
                                <b-select 
                                v-model="data.idType"
                                expanded 
                                required 
                                placeholde="Tipo de ID">
                                    <option value="CI">Cedula identidad</option>
                                    <option value="P">Pasaporte</option>
                                    <option value="O">Otro</option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-one-third">
                            <b-field label="Nro. Documento de identidad">
                                <b-input
                                v-model="data.idNumber"
                                required>
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-one-third">
                            <b-field label="Telefono">
                                <b-input 
                                v-model="data.phoneNumber"
                                required>
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-full has-text-centered m-t-20">
                            <b-button
                            rounded
                            :disabled="isDisabledButton"
                            class="is-custom"
                            @click="createOrder">
                                Crear orden
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>    
</template>

<script>
export default {
    props:{
        orderDetailModal:{
            type:Boolean,
            default:false
        },
        userEmail:{
            type:String,
            default:false
        },
        userProfile:{
            type:Object,
            default:{}
        }
    },
    data(){
        return{
            data:{
                email:this.userEmail,
                shipmentMethod:"retiro",
                firstName:this.userProfile.firstName,
                lastName:this.userProfile.lastName,
                location:this.userProfile.city,
                region:"",
                address:this.userProfile.address,
                number:"",
                phoneNumber:this.userProfile.phoneNumber,
                idNumber:this.userProfile.idNumber,
                idType:this.userProfile.idType,
                zipCode:"",
                shipmentModel:"",
            }
        }
    },
    methods:{
        closeModal(){
            this.$emit('modalChange', false)
        },
        createOrder(){
            this.$emit("savedOrder", this.data)
            this.closeModal()
        }
    },
    computed:{
        isDisabledButton(){
            return !this.data.email 
                || !this.data.shipmentMethod 
                || !this.data.firstName 
                || !this.data.lastName 
                || !this.data.location
                || !this.data.region
                || !this.data.address
                || !this.data.number
                || !this.data.phoneNumber
                || !this.data.idNumber
                || !this.data.idType
                || !this.data.zipCode
        },
    },
    
    
}
</script>


<style lang="scss" scoped>
.modal-add-to-list{
    border-radius: 20px;
}

.is-custom{
    color: var(--text-color);
    background: var(--primary);
}

</style>